/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable no-console */
import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import AuthCheckWrapper from '../../modules/AuthCheckWrapper';

import TenantPage from './TenantPage';
import RatePage from './RatePage';
import CommentPage from './CommentPage';
import ManagerPage from './ManagerPage';
import ManagerCommentPage from './ManagerCommentPage';
import SuccessPage from './SuccessPage';

import RatingAndReviewActions from '../../../flux/actions/RatingAndReviewActions';
import pathsManifest from '../../../pathsManifest';
import queryUtil from '../../../utils/queryUtils';

import ListingNotFound from './ListingNotFound';

class RatingAndReviewRoute extends React.Component {
  constructor(props) {
    super(props);

    const { currentListing } = this.props;

    this.state = {
      listingFound: Boolean(currentListing.address),
    };
  }

  componentDidMount() {
    const { query, dispatch, currentListing } = this.props;

    if (!currentListing.address && query.providerListingId) {
      const providerListingId = query.providerListingId;
      dispatch(
        RatingAndReviewActions.fetchListingByAliasEncoded({
          aliasEncoded: providerListingId,
          components: 'basic,photos',
        }),
      ).catch(() => {
        this.setState({ listingFound: false });
        console.error('Listing not found. Invalid providerListingId was passed.');
      });
    } else if (!currentListing.address) {
      this.setState({ listingFound: false });
      console.error('Listing not found. No providerListingId was passed.');
    }
  }
  render() {
    const { currentListing } = this.props;
    const { listingFound } = this.state;

    return (
      <AuthCheckWrapper requireStrongAuthentication={false}>
        <div className="inset-md">
          <Helmet>
            <title>Leave a Review</title>
          </Helmet>
          <Col xs={0} md={2} />
          <Col md={8}>
            <div className="stacked-lg">
              <div className="stacked-lg">
                <Center>
                  <Text type="h1" emphasize>
                    Leave a Review
                  </Text>
                  <Text type="body">{currentListing.address}</Text>
                </Center>
              </div>
              {!listingFound ? (
                <ListingNotFound />
              ) : (
                <React.Fragment>
                  <Route exact component={TenantPage} path={pathsManifest.propertyRatingAndReviewTenantPage} />
                  <Route exact component={RatePage} path={pathsManifest.propertyRatingAndReviewRatePage} />
                  <Route exact component={CommentPage} path={pathsManifest.propertyRatingAndReviewCommentPage} />
                  <Route
                    exact
                    component={ManagerCommentPage}
                    path={pathsManifest.propertyRatingAndReviewManagerCommentPage}
                  />
                  <Route exact component={ManagerPage} path={pathsManifest.propertyRatingAndReviewManagerPage} />
                  <Route exact component={SuccessPage} path={pathsManifest.propertyRatingAndReviewSuccessPage} />
                </React.Fragment>
              )}
            </div>
          </Col>
          <Col xs={0} md={2} />
        </div>
      </AuthCheckWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  currentListing: state.ratingAndReview.listing,
  query: queryUtil.parse(state.router.location.search),
});

export default connect(mapStateToProps)(RatingAndReviewRoute);
